export default {
  brandPrimary: "black",
  brandSecondary: "yellow",
  brandError: "#F5222D",
  white: "white",
  black: "#343a40",
  pink: "#e6007d",
  danger: "#e40b14"
};
